/**
 * Tracks the backend message ID emitted by the `user_message_persisted`
 * custom event during streaming.
 *
 * Returns the latest streaming message ID (reset on each new run).
 * This is used by the feedback action bar to identify the user message
 * for the current turn. Historical turns get their IDs from message metadata.
 */
import { useEffect, useState } from "react";
import type { HttpAgent } from "@ag-ui/client";

export function useStreamingMessageId(agent: HttpAgent): string | null {
  const [messageId, setMessageId] = useState<string | null>(null);

  useEffect(() => {
    const sub = agent.subscribe({
      onRunInitialized: () => {
        setMessageId(null);
      },
      onCustomEvent: ({ event }) => {
        if (event.name !== "user_message_persisted") {
          return;
        }
        const { message_id } = event.value ?? {};
        if (typeof message_id === "string") {
          setMessageId(message_id);
        }
      },
    });

    return () => sub.unsubscribe();
  }, [agent]);

  return messageId;
}
